<template>
<div class="chapter">
<div class="inner_page">
<div class="TPM_container">
<div class="Basic-Text-Frame">
<p class="copyright-title">Anonymous No More</p>
<p class="copyright-subtitle">A Mother's Faith-Filled Journey Through Addiction, Recovery &amp; Redemption</p>
<p class="copyright-text">© 2015 ALISA MASSEY. All rights reserved.</p>
<p class="copyright-text">No part of this publication may be reproduced or transmitted in any form or by any means, mechanical or electronic, including photocopying and recording, or by any information storage and retrieval system, without permission in writing from author or publisher (except by a reviewer, who may quote brief passages and/or show brief video clips in a review).</p>
<p class="copyright-text">Published in New York, New York, by Morgan James Publishing. Morgan James and The Entrepreneurial Publisher are trademarks of Morgan James, LLC. <br/><a href="http://www.MorganJamesPublishing.com" target="_blank">www.MorganJamesPublishing.com</a></p>
<p class="copyright-text">The Morgan James Speakers Group can bring authors to your live event. For more information or to book an event visit The Morgan James Speakers Group at <br/><a href="http://www.TheMorganJamesSpeakersGroup.com" target="_blank">www.TheMorganJamesSpeakersGroup.com.</a></p>
<p class="copyright-text">Disclaimer: The Publisher and the Author make no representations or warranties with respect to the accuracy or completeness of the contents of this work and specifically disclaim all warranties, including without limitation warranties of fitness for a particular purpose. No warranty may be created or extended by sales or promotional materials. The advice and strategies contained herein may not be suitable for every situation. This work is sold with the understanding that the Publisher is not engaged in rendering legal, accounting, or other professional services. If professional assistance is required, the services of a competent professional person should be sought. Neither the Publisher nor the Author shall be liable for damages arising herefrom. The fact that an organization or website is referred to in this work as a citation and/or a potential source of further information does not mean that the Author or the Publisher endorses the information the organization or website may provide or recommendations it may make. Further, readers should be aware that internet websites listed in this work may have changed or disappeared between when this work was written and when it is read.</p>
</div>
<div class="_idGenObjectLayout-1">
<img alt="BitLit" src="image/Bitlit.png"/>
<div class="Basic-Text-Frame">
<p class="copyright-isbn">ISBN 978-1-63047-285-6  paperback</p>
<p class="copyright-isbn">ISBN 978-1-63047-286-3  eBook</p>
<p class="copyright-isbn">ISBN 978-1-63047-287-0  Hardcover</p>
<p class="copyright-isbn">Library of Congress Control Number: </p>
<p class="copyright-isbn">2014941192</p>
<div class="padding-top-40">
<p class="copyright-credit-title">Cover Design by: </p>
<p class="copyright-isbn">Rachel Lopez</p>
<p class="copyright-isbn">rachel@r2cdesign.com</p>
</div>
<div class="padding-top-20">
<p class="copyright-credit-title">Interior Design by: </p>
<p class="copyright-isbn">Bonnie Bushman</p>
<p class="copyright-isbn">bonnie@caboodlegraphics.com</p>
</div>
</div>
</div>
<div class="Basic-Text-Frame">
<p class="copyright-text">In an effort to support local communities, raise awareness and funds, Morgan James Publishing donates a percentage of all book sales for the life of each book to Habitat for Humanity Peninsula and Greater Williamsburg.</p>
</div>
<div class="bottom">
<div class="_idGenPageitem-4">
<img alt="QR code" src="image/QR_code.png"/>
</div>
<p class="copyright-habitat">Get involved today, visit <br/><a href="http://www.MorganJamesBuilds.com" target="_blank">www.MorganJamesBuilds.com.</a></p>
<div class="_idGenPageitem-5">
<img alt="Habitat for Humanity" src="image/H4H.png"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781630472863_EPUB-1.vue?668cce5a